import React, { useState, useEffect } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"
import { DesktopOnly, PhoneOnly, OverflowWrapper } from "@/common/Mixin"
import Buttons from "@/common/components/_UI/Buttons"
import Intro from "@/common/components/_UI/Intro"
import SectionRow from "@/common/components/_Section/SectionRow"

import Head from "next/head"
import Sticky from "react-stickynode"
import { useRouter } from "next/router"
import dynamic from "next/dynamic"

import MetaData from "@/common/components/MetaData"
import Hero from "@/containers/WalletAsAService/animations/Hero/Hero"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))
const FeatureSection = dynamic(
  import("@/containers/WalletAsAService/FeatureSection")
)

const SectionLine = dynamic(import("@/common/components/SectionLine"), {
  ssr: false
})
const Footer = dynamic(import("@/containers/common/FooterNew"), { ssr: false })
const CTASection = dynamic(import("@/containers/WalletAsAService/CTASection"), {
  ssr: false
})
const WhyKG = dynamic(import("@/containers/WalletAsAService/WhyKG"), {
  ssr: false
})

const ShowCase = dynamic(import("@/containers/WalletAsAService/ShowCase"), {
  ssr: false
})
const Counter = dynamic(import("@/containers/WalletAsAService/Counter"), {
  ssr: false
})
const CasePopUp = dynamic(import("@/common/components/_Section/CasePopUp"), {
  ssr: false
})

const WalletAsAService = ({ t }) => {
  const { locale } = useRouter()
  const router = useRouter()
  const [ShowPopup, setShowPopup] = useState("close")
  const [PopContent, setPopContent] = useState()
  const [PopTheme, setPopTheme] = useState()
  const [LoadSection, setLoadSection] = useState(false)

  gsap.registerPlugin(ScrollTrigger)
  useEffect(() => {
    ScrollTrigger.create({
      trigger: ".loadable",
      start: "top 80%",
      end: "bottom 20%",
      // markers: true,
      onEnter: () => {
        setLoadSection(true)
      }
    })
  }, [])

  return (
    <>
      <>
        <MetaData
          title={t("meta.title")}
          description={t("meta.description")}
          url={t("meta.url")}
          image="https://i.ibb.co/SNvd1Mn/og-image-compliance.jpg"
          languageAlternates={[
            [
              {
                hrefLang: "en-US",
                href: "https://www.kryptogo.com/products/wallet-as-a-service"
              },
              {
                hrefLang: "zh-TW",
                href: "https://www.kryptogo.com/tw/products/wallet-as-a-service"
              },
              {
                hrefLang: "zh-CN",
                href: "https://www.kryptogo.com/cn/products/wallet-as-a-service"
              }
            ]
          ]}
        />
        <Head>
          <meta
            name="facebook-domain-verification"
            content="t1n6wqjocjqfbv1v5pgofo0nxnawdj"
          />
        </Head>
        <Sticky top={0} innerZ={100} activeClass="sticky-active">
          <NavbarNew />
        </Sticky>
      </>
      {LoadSection && (
        <>
          <CasePopUp
            t={t}
            locale={locale}
            content={PopContent}
            ShowPopup={ShowPopup}
            setShowPopup={setShowPopup}
            themeNew={PopTheme}
          />
        </>
      )}
      <OverflowWrapper>
        <Hero t={t} />
        {/* <div style={{ height: "100vh" }}></div> */}
        <div className="loadable">
          <SectionLine />
          <SectionRow
            id="counter"
            type="left top"
            glow
            content1={
              <Intro
                type=" big "
                title1={t("counter.title1")}
                title2={t("counter.title2")}
                desc={t("counter.desc")}
                content={
                  <DesktopOnly>
                    <Buttons
                      btns={[
                        {
                          content: t("button.1"),
                          href: `/contact/sales?referrer=${router.asPath}`,
                          id: "Waas-secend page-getstart"
                        },
                        {
                          content: t("button.2"),
                          href: "https://calendly.com/kordan",
                          target: "_blank",
                          id: "Waas-secend page-Demo"
                        }
                      ]}
                    />
                  </DesktopOnly>
                }
              />
            }
            content2={
              <>
                <Counter t={t} locale={locale} />
                <PhoneOnly>
                  <Buttons
                    btns={[
                      {
                        content: t("hero.cta"),
                        href: `/contact/sales?referrer=${router.asPath}`,
                        id: "Waas-secend page-getstart"
                      },
                      {
                        content: t("hero.cta2"),
                        href: `/contact/sales?referrer=${router.asPath}`,
                        id: "Waas-secend page-Demo"
                      }
                    ]}
                  />
                </PhoneOnly>
              </>
            }
          />
        </div>
        {LoadSection && (
          <>
            <SectionLine />
            <FeatureSection t={t} locale={locale} id="Start" />

            <SectionLine />
            <ShowCase
              t={t}
              locale={locale}
              setContent={setPopContent}
              ShowPopup={ShowPopup}
              setShowPopup={setShowPopup}
              setPopTheme={setPopTheme}
            />
            <SectionLine />

            <SectionRow
              center
              content1={
                <Intro
                  big
                  center
                  title1={t("features.title1")}
                  title2={t("features.title2")}
                />
              }
              content2={<WhyKG />}
            />
            <SectionLine />
            <CTASection
              title1={t("CTA.title1")}
              title2={t("CTA.title2")}
              btns={[
                {
                  content: t("button.1"),
                  href: `/contact/sales?referrer=${router.asPath}`,
                  id: "Waas-lastpage-getstart"
                },
                {
                  content: t("button.2"),
                  href: "https://calendly.com/kordan",
                  target: "_blank",
                  id: "Waas-lastpage-Demo"
                }
              ]}
            />
            <Footer />
          </>
        )}
      </OverflowWrapper>
    </>
  )
}

export default WalletAsAService
